export const GIT_BRANCH = "master"
export const GIT_HASH = "21fc63576cb49825f641df08d8614ef781e2f692"
export const BUILD_NUM = "25517"
export const THEME_COLOR = "#808080"
export const PRIMARY_COLOR = "#ffffff"
export const TERTIARY_COLOR = "#414142"
export const APP_NAME = "Production WL Build"
export const START_URL = "https://web-order.flipdish.co/client/productionwlbuild/latest/pwa.html"
export const WHITE_LABEL_ID = "3"
